import React from 'react';
import SearchBar from '../SearchBar';
import styled from 'styled-components';
import CustomButton from '../CustomButton/CustomButton';
import DataNotFound from '../DataItemFound/DataNotFound';
import CustomDataGrid2 from '../CustomDataGrid/CustomDataGrid2';
import { Catalog } from '@src/pages/Catalogs';
import { useNavigate, useParams } from 'react-router-dom';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import CustomPermission from '../Permissions/CustomPermission';
import { LockIcon } from '../Icons';
import { Box } from '@mui/material';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	padding: 16px;
	gap: 30px;
	overflow: scroll;
	@media screen and (max-width: 600px) {
		gap: 20px;
		margin-bottom: 68px;
	}
`;

const StyledDataGridHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	@media screen and (min-width: 750px) and (max-width: 800px) {
		button {
			width: 220px;
		}
	}
`;

//For Mobile View
const StyledBottomBtnContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 68px;
	padding: 16px;
	background: var(--chat-header-bg);
	border: 1.5px solid var(--gray-color-light);
	z-index: 100;
	position: fixed;
	bottom: 0;
`;

interface ListingProps {
	masterCatalogs?: boolean;
	catalogs: Catalog[];
	searchValue: string;
	handleSearch: (value: string) => void;
	windowDimensions: {
		width: number;
		height: number;
	};
	loadingData: boolean;
	filteredCatalogs: Catalog[];
	columns: any;
	onRowsSelectionHandler: (selectedRows: any) => void;
	handleRowClick: (rowData: any) => void;
}
const Listing: React.FC<ListingProps> = ({
	masterCatalogs = false,
	catalogs,
	searchValue,
	handleSearch,
	windowDimensions,
	loadingData,
	filteredCatalogs,
	columns,
	onRowsSelectionHandler,
	handleRowClick,
}) => {
	const navigate = useNavigate();
	const { id } = useParams();
	//Permission
	const checkPermission = usePermission();
	const canViewCatalogs = checkPermission(ALL_PERMISSION_MAP?.SUPPLIER?.CATALOG?.VIEW, id);
	const canDeleteCatalogs = checkPermission(ALL_PERMISSION_MAP?.SUPPLIER?.CATALOG?.DELETE, id);
	return (
		<>
			{canViewCatalogs ? (
				<>
					<Container>
						<StyledDataGridHeader>
							<SearchBar
								style={{
									width: '328px',
									height: '36px',
								}}
								value={searchValue}
								onChange={handleSearch}
								isLoading={false}
							/>
							{windowDimensions?.width > 750 ? (
								<CustomButton
									title={!catalogs?.length ? 'Create New Catalog' : 'Add New Catalog'}
									handleClick={() =>
										navigate(
											masterCatalogs
												? `/suppliers/${id}/catalogs/master/add`
												: `/suppliers/${id}/catalogs/add`
										)
									}
									disabled={loadingData}
									styles={{
										marginRight: '15px',
										width: '172px',
										height: '36px',
										borderRadius: '4px',
										padding: '7px 12px 7px 12px',
									}}
								/>
							) : null}
						</StyledDataGridHeader>
						<Box>
							{catalogs?.length ? (
								<CustomDataGrid2
									rows={filteredCatalogs}
									columns={columns}
									onRowsSelectionHandler={onRowsSelectionHandler}
									handleRowClick={handleRowClick}
									checkboxSelection={false}
									style={{
										transition: 'height 0.3s ease',
										maxHeight: 'calc(100vh - 250px)',
										minHeight: 'calc(100vh - 250px)',
									}}
								/>
							) : (
								<DataNotFound
									content="You haven't created any catalogs yet."
									operation="create"
									onClick={() =>
										navigate(
											masterCatalogs
												? `/suppliers/${id}/catalogs/master/add`
												: `/suppliers/${id}/catalogs/add`
										)
									}
								/>
							)}
						</Box>
					</Container>
					{windowDimensions?.width <= 750 ? (
						<StyledBottomBtnContainer>
							<CustomButton
								title={!catalogs?.length ? 'Create New Catalog' : 'Add New Catalog'}
								handleClick={() =>
									navigate(
										masterCatalogs
											? `/suppliers/${id}/catalogs/master/add`
											: `/suppliers/${id}/catalogs/add`
									)
								}
								disabled={loadingData}
								styles={{
									width: '328px',
									height: '36px',
								}}
							/>
						</StyledBottomBtnContainer>
					) : null}
				</>
			) : (
				<CustomPermission
					icon={<LockIcon />}
					title="We are sorry..."
					paragraph="You do not have permission to view catalogs. Contact 
				an administrator to get permission."
				/>
			)}
		</>
	);
};

export default Listing;
